export const OPTIMISER_PRO_SKU = "FIQT3"
// feature-promote-scenario-regime gates "Promote to Draft Regime" (FIQ-2279). Listing it here
// also makes it a product-sold feature, so ticking it on the Features screen only releases it
// to clients holding the Optimiser product rather than to everyone.
export const OPTIMISER_DEMANDS = [
    "feature-optimiser",
    "feature-promote-scenario-regime",
    "viewCosting",
    "manageScenarios",
]

export function applyOptimiserProductPrerequisites(licences, licenceGrants) {
    if (hasOptimiserProProduct(licenceGrants)) return licences

    const optimiserDemands = new Set(OPTIMISER_DEMANDS)
    return {
        ...licences,
        demands: (licences.demands || []).filter((demand) => !optimiserDemands.has(demand)),
    }
}

export function hasOptimiserProProduct(licenceGrants) {
    return (licenceGrants || []).some((licenceGrant) => licenceGrant?.sku === OPTIMISER_PRO_SKU)
}
